module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('span', {
    staticClass: "md-title"
  }, [_vm._v("REGISTRO DE FOTOS")]), _vm._v(" "), _c('span', {
    staticClass: "md-caption"
  }, [_vm._v("Nesta etapa você precisa adicionar as fotos dos "), _c('i', [_vm._v("vertices")]), _vm._v(" e "), _c('i', [_vm._v("equipamentos")]), _vm._v(" de cada ÁREA definida.")]), _vm._v(" "), _c('p', {
    staticClass: "md-caption"
  }, [_vm._v("*"), _c('b', [_vm._v("Vértices")]), _vm._v(" são as quatro (4) quinas de cada instalação cadastrada, detalhando o ambiente como um todo."), _c('br')]), _vm._v(" "), (_vm.certificationProcess) ? _c('md-list', _vm._l((_vm.certificationProcess.areas), function(area) {
    return _c('md-list-item', {
      key: area['.key']
    }, [(area.status === 0 || !area.status) ? _c('md-icon', {
      staticClass: "md-warn"
    }, [_vm._v("warning")]) : _c('md-icon', {
      staticClass: "done"
    }, [_vm._v("done_all")]), _vm._v(" "), _c('span', [_vm._v("Área: " + _vm._s(area.name))]), _vm._v(" "), _c('span', {
      staticClass: "caption"
    }, [_vm._v(_vm._s(area.description))]), _vm._v(" "), _c('md-divider')], 1)
  }), 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-row": "",
      "md-flex": "",
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('md-button', {
    staticClass: "md-accent md-raised",
    on: {
      "click": function($event) {
        return _vm.openPhotos()
      }
    }
  }, [_vm._v("FOTOS INSTALAÇÕES/EQUIPAMENTOS")])], 1), _vm._v(" "), (_vm.certificationProcess.status > 4) ? _c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('md-button', {
    staticClass: "md-primary md-raised",
    on: {
      "click": function($event) {
        return _vm.finishPhotos()
      }
    }
  }, [_vm._v("Próxima Etapa")])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3835618d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PhotosList.vue
// module id = 828
// module chunks = 1